import { Serializable } from "../core";
import { Product } from "./product";

export type HomeSectionType = "2Image" | "4Image" | "Scroll";

export type HomeSectionImage = { id: string; image: string; link: string };

export type HomeSectionItem = { product: Product; index: number };

export class HomeSection implements Serializable<HomeSection> {
  id!: string;
  title!: string;
  description!: string;
  images!: HomeSectionImage[];
  items!: HomeSectionItem[];
  type!: HomeSectionType;
  isActive!: boolean;

  deserialize(json: any): HomeSection {
    this.id = json.id.toString();
    this.title = json.title;
    this.description = json.description;
    this.images = json.images.map((json: any) => {
      return {
        id: json.id.toString(),
        image: json.image,
        link: json.link,
      };
    });
    this.items = json.items.map((json: any) => {
      return {
        index: json.index,
        product: new Product().deserialize(json.product),
      };
    });
    this.type = json.type as HomeSectionType;
    this.isActive = json.is_active;
    return this;
  }
}
